import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  getAllDocumentsData,
  setDocumentID,
  setDocumentName,
  setDocumentData,
  addDocumentData,
  getDocumenteByIdData,
  generateAiQuestionairesData,
  addorUpdateDocumentQuestionsData,
  setViewingDocData,
  updateDocumentcomplienceStatusData,
  getAllDocumentsByEmailData,
  updateDocumentAssignmentsData,
  UpdateMultipleDocumentcomplienceStatusData,
  setFolderData,
} from "../features/documentServiceSlice/documentServiceSlice";

const reducerName = "documentService";

// #region State Setters
export const setCurrentDocumentID = (documentId) => {
  dispatch(setDocumentID(documentId));
};

export const setCurrentDocumentName = (documentName) => {
  dispatch(setDocumentName(documentName));
};

export const setCurrentDocumentData = (documentData) => {
  dispatch(setDocumentData(documentData));
};
export const setViewingDoc = (documentData) => {
  dispatch(setViewingDocData(documentData));
};
export const setFolder = (documentData) => {
  dispatch(setFolderData(documentData));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getAllDocuments = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAllDocumentsData({
        pharmacyId,
        serviceId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const addDocument = async (data) => {
  let result = null;

  try {
    result = await dispatch(addDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const getDocumentById = async (documentId) => {
  let result = null;

  try {
    result = await dispatch(getDocumenteByIdData(documentId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, documentId);
    result = null;
  }

  return result;
};
export const generateAiQuestionaires = async (data) => {
  let result = null;

  try {
    result = await dispatch(generateAiQuestionairesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const addorUpdateDocumentQuestions = async (data) => {
  let result = null;

  try {
    result = await dispatch(addorUpdateDocumentQuestionsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const updateDocumentcomplienceStatus = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateDocumentcomplienceStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const getAllDocumentsByEmail = async () => {
  let result = [];
  try {
    result = await dispatch(getAllDocumentsByEmailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const updateDocumentAssignments = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateDocumentAssignmentsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const UpdateMultipleDocumentComplianceStatus = async (data) => {
  let result = null;

  try {
    result = await dispatch(UpdateMultipleDocumentcomplienceStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
// #endregion
